import { Route } from 'react-router-dom';
import { MetaTags } from 'src/components/MetaTags/meta-tags';
import { Reports, REPORTS_NAVIGATION } from 'src/pages/Reports';
import { ProtectedPage } from 'src/routes/components/protected-page';
import { getRoutePath } from 'src/routes/utils';

export const ReportsRoutes = ({ relative }: { relative?: boolean }) => (
  <Route
    element={
      <ProtectedPage
        redirectTo={getRoutePath(REPORTS_NAVIGATION[0].path, relative)}
        allowedRules={REPORTS_NAVIGATION[0].allowedRules}
      />
    }
  >
    <Route
      path={getRoutePath(REPORTS_NAVIGATION[0].path, relative)}
      element={
        <MetaTags title="Subscriptions">
          <Reports />
        </MetaTags>
      }
    />
  </Route>
);
